import { Component, Input, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr'
import { DashboarduiService } from 'src/app/components/Shared/Service/dashboardui.service';
import { LocalstorageService } from '../Shared/Service/localstorage.service';
import { Observable, Subject, interval } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatSelect } from '@angular/material';
declare var $: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DashboarduiService]
})

export class DashboardComponent {
  @Input() TechURL: any;
  @Input() UserURL: any;
  @ViewChild('select', { static: false }) select: MatSelect | any;
  @ViewChild('multiSelect', { static: false }) multiSelect: any;
  dropdownDeptData: any
  pmsCustCodeKey: any
  apiresult: any;
  hotellistproperty: any;
  hotelName: any;
  dateTime: any;
  flag: any;
  UserId: any;
  productId: any;
  lstGetCMHotelsCode: any;
  errorMsgSubscription: any;
  displayContent: any
  selectedItemsList = []
  saveTrueValues = [];
  today: any;
  selectedDate: any;
  Val: any;
  isProgressing: Boolean = false;
  Pmscodevalue: any;
  Userid: any;
  lastModifiedBy: any;
  modifiedDateTime: any;
  heartBeatData: any;
  phaseIIheartBeatData:any;
  windowServiceData: any;
  hotelSearchDataStatus: any;
  hotelNameData: any;
  hotelCityData: any;
  hotelCodeData: any;
  hotelAreaData: any;
  statisticsData: any;
  activeCMStatus: any
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  constructor(public localStorage: LocalstorageService, public router: Router, private apiCallIdsService: DashboarduiService, private datePipe: DatePipe, private toastr: ToastrService) {

  }

  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  ngOnInit() {

    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription = true
    this.displayContent = false
    this.editDataAssign();
    this.statisticsReport();
    this.Pmscodevalue = localStorage.getItem("hotelCodeStoreValue")
    console.log('get hotelCodeKeyValue = ', this.Pmscodevalue)
    this.dropdownSettingsDept = {
      idField: 'pmscode',
      textField: 'pmsname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name",
    };

  }


  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.Pmscodevalue = this.selectedDeptItems[0].pmscode
        console.log('pms code value = ', this.Pmscodevalue)
        this.isProgressing = true;
        this.errorMsgSubscription = false
        this.displayContent = true
        this.apiCallIdsService
          .readWindowsServiceVersion(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readWindowsServiceVersion =', data)
            if (data.length > 0) {
              this.windowServiceData = data[0].windowsServiceVersion
            } else {
              this.windowServiceData = ""
            }

          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data)
            if (data.length > 0) {
              this.heartBeatData = data[0].heartBeat

              // For blinking the record
              const today = new Date()
              console.log('Today Date = ', today);
              this.currentDateStore = today.toLocaleTimeString('it-IT')
              console.log('Today Date = ', this.currentDateStore);
              this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
              var start = this.storeHeartBeatValue.split(":");
              var end = this.currentDateStore.split(":");
              var startDate = new Date(0, 0, 0, start[0], start[1], 0);
              var endDate = new Date(0, 0, 0, end[0], end[1], 0);
              var diff = endDate.getTime() - startDate.getTime();
              var hours = Math.floor(diff / 1000 / 60 / 60);
              diff -= hours * 1000 * 60 * 60;
              var minutes = Math.floor(diff / 1000 / 60);
              // console.log('minutes difference',minutes)
              console.log('minutes difference', hours + ":" + minutes)
              if ((hours + ":" + minutes) > "0:30") {
                console.log('blinkOfflineHotel true')
                this.blinkOfflineHotel = true
              } else {
                console.log('blinkOfflineHotel false')
                this.blinkOfflineHotel = false
              }

            } else {
              this.heartBeatData = ""
            }

          });
          //Indhuja 27-11-2025 Start
          this.apiCallIdsService
          .readPhaseIIHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data)
            if (data.length > 0) {
              this.phaseIIheartBeatData =data[0].heartBeat
              console.log("phaseIIheartBeatData",this.phaseIIheartBeatData)
              // For blinking the record
              const today = new Date()
              console.log('Today Date = ', today);
              this.currentDateStore = today.toLocaleTimeString('it-IT')
              console.log('Today Date = ', this.currentDateStore);
              this.storeHeartBeatValue = this.GetParseonlyDateTime(this.phaseIIheartBeatData)
              var start = this.storeHeartBeatValue.split(":");
              var end = this.currentDateStore.split(":");
              var startDate = new Date(0, 0, 0, start[0], start[1], 0);
              var endDate = new Date(0, 0, 0, end[0], end[1], 0);
              var diff = endDate.getTime() - startDate.getTime();
              var hours = Math.floor(diff / 1000 / 60 / 60);
              diff -= hours * 1000 * 60 * 60;
              var minutes = Math.floor(diff / 1000 / 60);
              // console.log('minutes difference',minutes)
              console.log('minutes difference', hours + ":" + minutes)
              if ((hours + ":" + minutes) > "0:15") {
                console.log('blinkOfflineHotel true')
                this.blinkOfflineHotel = true
              } else {
                console.log('blinkOfflineHotel false')
                this.blinkOfflineHotel = false
              }

            } else {
              this.phaseIIheartBeatData = ""
            }

          });
          //Indhuja 27-11-2025 End
        this.searchHotelData();
        // this.heartBeatCallBack()
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
           this.PhaseIIheartbeatFunction();
        });
        setTimeout(() => {
          this.Val = '';
          this.isProgressing = false;
          this.editDataAssign();
        }, 1000);
        setTimeout(() => {
          this.getActiveCMStatus();
        }, 1000);
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        // this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }


  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }
  statisticsReport() {
    this.apiCallIdsService
      .statisticsData()
      .subscribe((data) => {
        console.log('Statistics Data =', data)
        this.statisticsData = data
      });
  }
  searchHotelData() {
    this.apiCallIdsService
      .readHotelSearch(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHotelSearch =', data)
        this.hotelNameData = data[0].hotelname
        this.hotelCityData = data[0].city
        this.hotelCodeData = data[0].pmscustcode
        this.hotelSearchDataStatus = data[0].recordstatus
        this.hotelAreaData = data[0].area
      });
  }

  getActiveCMStatus() {
    this.apiCallIdsService
      .dashboardActivateCM(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('dashboardActivateCM =', data)
        this.activeCMStatus = data
      });
  }

  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }

  editDataAssign() {
    this.apiCallIdsService
      .getIDSUsersProperties(this.Userid)
      .subscribe((data) => {
        console.log(data)

        this.lstGetCMHotelsCode = data.filter((obj, pos, arr) => {
          return arr
            .map(mapObj => (mapObj.pmsname))
            .indexOf(obj.pmsname) == pos;
        });
        console.log('data value = ', this.lstGetCMHotelsCode)
        this.dropdownDeptData = this.lstGetCMHotelsCode
        this.hotellistproperty = this.lstGetCMHotelsCode;
      });

  }
  //Indhuja 27-11-2025 Start
 PhaseIIheartbeatFunction() {
    this.apiCallIdsService
      .readPhaseIIHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('phaseIIreadHeartbeat =', data[0])
        this.phaseIIheartBeatData = data[0].heartBeat
      });
  }
  //Indhuja 27-11-2025 end
  Search(event: any) {
    console.log('event= ', event)
    if (this.Val != '')
      this.lstGetCMHotelsCode = this.hotellistproperty.filter((res: { pmscode: { toString: () => string; }; pmsname: { toString: () => string; }; }) => {
        return res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
      });
  }
}